import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { BookOpen } from "lucide-react";
import SystemHealthDot from "./SystemHealthDot";
import CurrencyPicker from "./CurrencyPicker";

export default function Navigation() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <nav
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-[var(--rl-border)]"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
          <div className="w-7 h-7 bg-[var(--rl-brand)] flex items-center justify-center">
            <span className="text-white font-display font-black text-sm">AI</span>
          </div>
          <span className="font-display font-black tracking-tight text-lg">
            Adrigo Insights<span className="text-[var(--rl-accent)]"> AI</span>
          </span>
        </Link>
        <div className="flex items-center gap-3">
          {/* Ops-health indicator: hidden until the first probe lands so we don't
              flash a red dot during cold start. Visible to every visitor. */}
          <SystemHealthDot />
          <CurrencyPicker />
          {!user && (
            <>
              <Link
                to="/resources"
                className="text-sm font-semibold text-[var(--rl-text-secondary)] hover:text-[var(--rl-brand)] transition-colors hidden sm:inline-flex"
                data-testid="nav-how-it-works-link"
              >
                How It Works
              </Link>
              <Link
                to="/login"
                className="text-sm font-semibold hover:text-[var(--rl-brand)] transition-colors"
                data-testid="nav-login-link"
              >
                Sign in
              </Link>
              <Link
                to="/register/client"
                className="text-sm font-semibold bg-[var(--rl-brand)] text-white px-4 py-2 rounded-sm hover:bg-[var(--rl-text)] transition-colors"
                data-testid="nav-client-register-cta"
              >
                For Brands
              </Link>
            </>
          )}
          {user && (
            <>
              <Link
                to={user.role === "client" ? "/client" : "/panelist"}
                className="text-sm font-semibold hover:text-[var(--rl-brand)] transition-colors"
                data-testid="nav-dashboard-link"
              >
                Dashboard
              </Link>
              <Link
                to="/account/profile"
                className="text-sm font-semibold hover:text-[var(--rl-brand)] transition-colors hidden sm:inline-flex"
                data-testid="nav-account-link"
                title="Profile & preferences"
              >
                Account
              </Link>
              {user.role === "client" && (
                <>
                  <Link
                    to="/client/memory"
                    className="text-sm font-semibold hover:text-[var(--rl-brand)] transition-colors hidden sm:inline-flex"
                    data-testid="nav-memory-link"
                  >
                    Memory
                  </Link>
                  <Link
                    to="/client/compare"
                    className="text-sm font-semibold hover:text-[var(--rl-brand)] transition-colors hidden sm:inline-flex"
                    data-testid="nav-compare-link"
                  >
                    Compare
                  </Link>
                  <Link
                    to="/dashboard/help"
                    className="inline-flex items-center gap-1.5 text-sm font-semibold hover:text-[var(--rl-brand)] transition-colors"
                    data-testid="nav-help-link"
                    title="Help & Documentation"
                  >
                    <BookOpen className="w-4 h-4" />
                    <span className="hidden sm:inline">Help & Documentation</span>
                    <span className="sm:hidden">Help</span>
                  </Link>
                </>
              )}
              <button
                onClick={handleLogout}
                className="text-sm font-semibold text-[var(--rl-text-secondary)] hover:text-[var(--rl-text)] transition-colors"
                data-testid="nav-logout-btn"
              >
                Sign out
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
